// extracted by mini-css-extract-plugin
export default {"addRecordForm":"AddRecordModal_addRecordForm__L-Hqj","addRecordForm__submitButton":"AddRecordModal_addRecordForm__submitButton__KKBvh"};